/**
 * Step Component Names Enum not only for the activation steps
 * but also for the onboarding steps ZERO DEPENDENCIES
 *
 * This file contains only the enum, no component imports.
 * The actual component registry is in stepComponents.ts
 */

/**
 * Enum for step component names
 * Provides type-safe component references and better autocomplete
 */
export enum StepComponentName {
  // General
  SummaryStep = 'SummaryStep',

  // Pre-account steps
  MeetAccountableBanking = 'MeetAccountableBanking',
  PeppolBanking = 'PeppolBanking',
  ExpensesDescription = 'ExpensesDescription',
  AccIbanOnInvoicesOnboardingStep = 'AccIbanOnInvoicesOnboardingStep',
  TaxesDescription = 'TaxesDescription',
  FullTransparency = 'FullTransparency',
  PersonalInfoStep = 'PersonalInfoStep',
  BusinessAddressStep = 'BusinessAddressStep',
  BusinessActivityStep = 'BusinessActivityStep',
  FinanzamtDocUploader = 'FinanzamtDocUploader',
  BornDetailsStep = 'BornDetailsStep',
  ResidencyDetailsStep = 'ResidencyDetailsStep',
  ConfirmIdentity = 'ConfirmIdentity',

  // Post-account steps
  HowIsIntegratedStep = 'HowIsIntegratedStep',
  TaxesDescriptionStep = 'TaxesDescriptionStep',
  AccIbanOnInvoicesActivationStep = 'AccIbanOnInvoicesActivationStep',
  IssueCardStep = 'IssueCardStep',
  CardDesignStep = 'CardDesignStep',
  YourCardReadyStep = 'YourCardReadyStep',
  CardToWalletStep = 'CardToWalletStep',
  TopUpStep = 'TopUpStep',
  ReadyToGoStep = 'ReadyToGoStep',
}
